import { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import cn from 'classnames'

import { useLanguage } from '../context/LangaugeContextProvider/LangaugeContextProvider'
import SearchBar from '../components/ui/SearchBar/SearchBar'
import Button from '../components/ui/Button/Button'
import useIsMobile from '../hooks/useIsMobile'
import NpciIcon from '../components/ui/icons/NPCI'

import styles from './Header.module.scss'
import search from '../assets/images/search.svg'
import downArrow from '../assets/images/down-arrow.svg'
import menu from '../assets/images/menu.svg'
import close from '../assets/images/close.svg'

function Navbar({
  isMenuOpen,
  handleClick,
  handleClose,
  className,
  setModalVisibility,
  loading,
  langauges = [],
  extraMenus = [],
}) {
  const { pathname } = useLocation()
  const { language, setLanguage } = useLanguage()
  const [isSearchBarVisible, setIsSearchBarVisible] = useState(false)
  const searchBarRef = useRef(null)
  const isMobile = useIsMobile()

  const handleSearchIconClick = () => {
    const navCoverElement = document.getElementById('nav-cover')
    navCoverElement.style.display = 'block'
    setIsSearchBarVisible(true)
    handleClose()
  }

  const handleClickOutside = (event) => {
    if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
      setIsSearchBarVisible(false)
      const navCoverElement = document.getElementById('nav-cover')
      navCoverElement.style.display = 'none'
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const clickHandler = () => {
    if (pathname === '/') {
      window.scrollTo(0, 0)
    }
    if (handleClose) {
      handleClose()
    }
  }

  const handleLanguageClick = (e, lang) => {
    setLanguage({ ...lang })
  }

  const handleExtraMenuClick = (path) => {
    handleClick(undefined, path)
  }

  return (
    <div
      className={cn(styles.navbarContainer, className, {
        [styles['py-1rem']]: isSearchBarVisible,
      })}
    >
      {(!isMobile || !isSearchBarVisible) && (
        <Link to="/" onClick={clickHandler}>
          <NpciIcon
            ariaLabel={'NIPL Home'}
            className={styles.headerLogoContainer}
          />
        </Link>
      )}
      {!loading && (
        <div className={cn(styles.rightContainer)}>
          {!isMobile && !isSearchBarVisible && extraMenus.length > 0 ? (
            <div className={styles.menuBtnsContainer}>
              {extraMenus.map((me) => (
                <Button
                  key={me.path}
                  aria-label={me.label}
                  classname={styles.menuButton}
                  onClick={() => handleExtraMenuClick(me.path)}
                >
                  {me.label}
                </Button>
              ))}
            </div>
          ) : null}
          {/* <div className={styles.searchContainer}>
            {isSearchBarVisible ? (
              <div ref={searchBarRef} className={cn(styles.searchBar)}>
                <SearchBar
                  placeholder="Search..."
                  onChange={(e) => {}}
                  setModalVisibility={setModalVisibility}
                  allSearchLabel={'All search result for'}
                  buttonLabel={'Press Enter'}
                />
              </div>
            ) : (
              <Button onClick={handleSearchIconClick}>
                <img src={search} alt="Search" width={24} />
              </Button>
            )}
          </div> */}
          {(!isMobile || !isSearchBarVisible) && (
            <Dropdown className={cn(styles.customDropdown)}>
              <Dropdown.Toggle
                id="dropdown-basic"
                className={cn(styles.btnPrimary)}
              >
                {language?.label?.slice(0, 3).toUpperCase()}
                <img src={downArrow} alt={'Down Arrow'} width={24} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="flex flex-col">
                {langauges.map((lan) => (
                  <Dropdown.Item
                    key={lan.code}
                    onClick={(e) => handleLanguageClick(e, lan)}
                  >
                    {lan.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}
          <img
            onClick={handleClick}
            src={!isMenuOpen ? menu : close}
            alt="Menu"
            className={styles.menuIcon}
          />
        </div>
      )}
    </div>
  )
}

export default Navbar
